<div class="p-5 d-flex flex-column justify-content-center align-items-center h-100">
  <div class="img-logo d-flex align-items-center ps-2 logo-animated mb-4">
    <img src="/assets/img/orbis/Logo_PRINCIPAL.png" height="100" alt="">
  </div>


  <div *ngIf="vista === 'social'" class="text-center">


    <h2 class="mt-3">{{ 'wellcomeLogin' | translate }}</h2>
    <p>{{ 'wellcomeLoginDesc' | translate }}</p>



    <!-- Botón Google -->
    <button type="button" class="social-btn gbtn" aria-label="Iniciar sesión con Google" (click)="loginWithGoogle()">
      <span class="social-btn__logo" aria-hidden="true">
        <!-- Logo Google -->
        <svg width="18" height="18" viewBox="0 0 48 48" focusable="false" aria-hidden="true">
          <path fill="#EA4335"
            d="M24 9.5c3.54 0 6.72 1.22 9.22 3.6l6.9-6.9C35.9 2.2 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l8.06 6.26C12.35 13.04 17.74 9.5 24 9.5z" />
          <path fill="#4285F4"
            d="M46.5 24c0-1.61-.16-3.15-.46-4.63H24v9.26h12.7c-.55 2.97-2.2 5.49-4.7 7.18l7.18 5.57C43.94 37.55 46.5 31.3 46.5 24z" />
          <path fill="#FBBC05"
            d="M10.62 19.48l-8.06-6.26C.9 15.87 0 19.83 0 24c0 4.17.9 8.13 2.56 10.78l8.06-6.26C9.84 26.22 9.5 25.14 9.5 24s.34-2.22 1.12-4.52z" />
          <path fill="#34A853"
            d="M24 48c6.48 0 11.94-2.13 15.9-5.8l-7.18-5.57c-2 1.35-4.57 2.17-8.72 2.17-6.26 0-11.65-3.54-13.38-8.98l-8.06 6.26C6.51 42.62 14.62 48 24 48z" />
        </svg>
      </span>
      <span class="social-btn__text">{{"continueWithGoogle" | translate}}</span>
      <span *ngIf="loadingGoogle" class="social-btn__spinner"></span>
    </button>


    <!-- Botón Apple -->
    <button type="button" class="social-btn apple-btn light" aria-label="Iniciar sesión con Apple" (click)="loginWithApple()" [disabled]="loadingApple">
      <span class="social-btn__logo apple-logo" aria-hidden="true">
        <i class="fab fa-apple" style="font-size: 20px;"></i>
      </span>
      <span class="social-btn__text">{{"continueWithApple" | translate}}</span>
      <span *ngIf="loadingApple" class="social-btn__spinner"></span>
    </button>


    <!-- Botón Email -->
    <button type="button" class="social-btn email-btn btn-primary" aria-label="Iniciar sesión con Email"
      (click)="vista='email'">
      <span class="social-btn__logo" aria-hidden="true">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path
            d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
        </svg>
      </span>
      <span class="social-btn__text">{{"continueWithEmail" | translate}}</span>
    </button>


    <div class="mt-3">
      <p> {{'noAccount' | translate}} <span class="link-style" (click)="navigateToRegister()"> {{'registerNow' | translate}} </span></p>
    </div>


  </div>


  <div *ngIf="vista !='social'" class="text-center w-100">


<div
  *ngIf="errorLogin"
  #loginAlert
  class="alert alert-danger w-100 shadow-sm border-0 d-flex align-items-center"
  role="alert">

  <!-- Columna izquierda: icono -->
  <div class="alert-icon d-flex align-items-center justify-content-center">
    <i class="fa-solid fa-triangle-exclamation"></i>
  </div>

  <!-- Columna derecha: texto -->
  <div class="alert-text ms-3">
    {{ 'invalidCredentials' | translate }}
  </div>
</div>


    <div class="text-center mt-2">
      <p style="font-size: larger;"> <strong style="font-size: larger; font-weight: bold;"> {{'signIn2' | translate}} </strong> {{'enjoyBestExperience' | translate}}:</p>
    </div>
    <div class="mt-3">
      <input class="input_element" type="email" id="email" placeholder="{{'emailPlaceholder' | translate}}" [(ngModel)]="username">
    </div>
    <div class="mt-1">
      <div class="password_wrap">
        <input class="input_element" [type]="showPassword ? 'text' : 'password'" id="password" placeholder="{{'passwordPlaceholder' | translate}}" [(ngModel)]="password"
          autocapitalize="off" autocorrect="off" spellcheck="false">
        <button type="button" class="btn btn-link p-0 position-absolute top-50 end-0 translate-middle-y me-3 text-secondary" [attr.aria-pressed]="showPassword" (click)="showPassword = !showPassword">
          <i class="fas" [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
        </button>
      </div>
    </div>
    <div class="d-flex flex-column align-items-center w-100">
      <div class="mt-2 w-100 d-flex justify-content-center">
        <button class="social-btn email-btn btn-primary" (click)="login()"> {{'next' | translate}}</button>
      </div>
      <div class="mt-3  d-flex justify-content-between   ">
        <span class="link-style me-5 ps" (click)="vista='social'; showPassword = false">← {{'return' | translate}}</span>
        <span class="link-style" (click)="navigateToForgot()"> {{'forgotPass2' | translate}}</span>
      </div>
    </div>

  </div>

</div>
